if (!window.__sizeGuidePopupSyncBound) {
  window.__sizeGuidePopupSyncBound = true;

  const SELECTORS = {
    openDrawer: 'x-drawer[data-size-guide][open]',
    radio: 'input[type="radio"][data-option-position]',
    popover: 'x-popover',
    label: 'label',
    submitButton: 'button[data-size-guide-submit]',
  };

  const POPOVER_ID_PREFIX = 'popover-variant-dropdown-sg-';
  const SELECTED_VALUE_SUFFIX = '-selected-value';

  const isSizeGuidePopover = (popover) => popover?.id.startsWith(POPOVER_ID_PREFIX);

  document.addEventListener('change', (event) => {
    const radio = event.target.closest(SELECTORS.radio);
    if (!radio) return;

    const popover = radio.closest(SELECTORS.popover);
    if (!isSizeGuidePopover(popover)) return;

    const label = radio.closest(SELECTORS.label)?.textContent.trim();
    if (!label) return;

    const openDrawer = document.querySelector(SELECTORS.openDrawer);
    if (!openDrawer) return;

    const span = openDrawer.querySelector(`#${CSS.escape(popover.id)}${SELECTED_VALUE_SUFFIX}`);
    if (span) span.textContent = label;
  });

  document.addEventListener('cart:change', () => {
    document.querySelectorAll(SELECTORS.openDrawer).forEach((drawer) => drawer.hide?.());
  });

  // The size-guide drawer has `shouldAppendToBody: true`, so opening it moves
  // it to <body>. When the user then changes the variant from inside the drawer
  // (via the bra-popup back/chest calculator or the variant picker), Shopify's
  // <variant-picker> fetches the new section HTML and dispatches `product:rerender`.
  // The new fragment ALSO contains a freshly-rendered drawer at the original
  // location — so we'd end up with two <x-drawer> nodes sharing the same id,
  // which breaks id lookups (radios, spans, …) and leaves the user staring at
  // a "stale" popup until they close + reopen it.
  //
  // Two cooperating mechanisms keep the drawer single + reusable:
  //
  //   (1) On script load, move the drawer out of its variant-picker location
  //       into <body>. From then on the drawer lives outside any partial-rerender
  //       block, so Shopify's `<product-rerender>` won't touch it. Because the
  //       drawer is already in body, Drawer.show()'s `if (parentElement !== body)`
  //       check stays false forever and `_originalParentBeforeAppend` stays null
  //       — meaning hide() never tries to move the drawer back to a (possibly
  //       detached) original parent.
  //
  //   (2) On `product:rerender`, strip any drawer that appears in the incoming
  //       fragment, so the partial swap-in doesn't introduce a fresh duplicate.
  //       This runs in capture phase because the event doesn't bubble — Shopify
  //       dispatches it with the default `bubbles: false`.
  document.querySelectorAll('x-drawer[data-size-guide]').forEach((drawer) => {
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
  });

  document.addEventListener('product:rerender', (event) => {
    const fragment = event.detail?.htmlFragment;
    if (!fragment) return;
    fragment.querySelectorAll('x-drawer[data-size-guide]').forEach((dup) => dup.remove());
  }, { capture: true });

  // The footer "Ajouter au panier" button lives inside <x-drawer slot="footer">,
  // and the native `form="…"` attribute association can break when a button
  // sits inside a custom element's slotted region (the <product-form> never
  // sees the submit event). We bridge that here: on click, find the target
  // form by id and call `requestSubmit()` so the normal submit listeners on
  // <product-form> still fire.
  document.addEventListener('click', (event) => {
    const btn = event.target.closest(SELECTORS.submitButton);
    if (!btn) return;

    const formId = btn.dataset.sizeGuideSubmit;
    const form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    event.preventDefault();
    form.requestSubmit(btn);
  });
}
